import { Injectable } from "@angular/core";
import { QuotesHttpService } from "./quotes-http.service";
import { forkJoin, map, Observable, of } from "rxjs";
import { IQuote } from "./quotes.interface";
import { HttpService } from "../../../../http.service";
import { CompaniesService } from "../../companies-page/companies/companies.service";
import { ClientsService } from "../../clients-page/clients/clients.service";
import { AuthService } from "../../../shared/services/auth.service";
import { SettingsService } from "../../settings-page/settings/settings.service";
import { CategoriesService } from "../../categories-page/categories/categories.service";
import { ICompany } from "../../companies-page/companies/companies.interface";
import { ICategory } from "../../categories-page/categories/categories.interface";

@Injectable()
export class QuotesService {
  public http: QuotesHttpService;

  constructor(
    private _http: HttpService,
    private _QuotesHttpService: QuotesHttpService,
    private _CompaniesService: CompaniesService,
    private _ClientsService: ClientsService,
    private _AuthService: AuthService,
    private _SettingsService: SettingsService,
    public _CategoriesService: CategoriesService,
  ) {
    this.http = this._QuotesHttpService;
  }

  getQuote(quote: any): Observable<any> {
    return !(quote && quote._id) ? of(undefined) : this._QuotesHttpService.getQuote(quote._id);
  }

  getRawQuote(quote: any): Observable<IQuote | any> {
    return !(quote && quote._id) ? of(undefined) : this._QuotesHttpService.getRawQuote(quote._id);
  }

  getClient(id: any): Observable<ICompany> {
    return !id ? of(undefined) : this._ClientsService.getClient(id);
  }

  getCompany(id: any): Observable<ICompany> {
    return !id ? of(undefined) : this._CompaniesService.getCompany(id);
  }

  getSetting(setting: any): Observable<any> {
    return !setting ? of(undefined) : this._SettingsService.getCompanySetting(setting)
  }

  getCategories(): Observable<ICategory[]> {
    return this._CategoriesService.getCategories({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'name', skip: 0, limit: 1000
    })
  }

  createQuote(quote: IQuote): Observable<IQuote> {
    if (quote.details) {
      quote.details.forEach(det => {
        // delete det.costsubtotal;
        if (!det.serviceAgreement) delete det.serviceAgreement;
        if (!det.task) delete det.task;
        if (!det.product) delete det.product;
      });
    }
    return this._QuotesHttpService.createQuote(quote);
  }

  updateQuote(quote: IQuote): Observable<IQuote> {
    if (quote.details) {
      quote.details.forEach((det: any) => {
        // delete det.costsubtotal;
        if (!det.serviceAgreement) delete det.serviceAgreement;
        if (!det.task) delete det.task;
        if (!det.product) delete det.product;
        if (det.product?._id) det.product = det.product._id;
        delete (det as any)._id;
      });
    }
    return this._QuotesHttpService.updateQuote(quote);
  }

  deleteQuote(quote: IQuote): Observable<any> {
    return !(quote && quote._id) ? of(undefined) : this._QuotesHttpService.deleteQuote(quote);
  }

  restoreQuote(quote: IQuote): Observable<any> {
    return !(quote && quote._id) ? of(undefined) : this._QuotesHttpService.restoreQuote(quote);
  }

}